import { DatePicker } from '@progress/kendo-react-dateinputs'
import { Popup } from '@progress/kendo-react-popup';
import classnames from 'classnames'
import pipe from 'lodash/fp/pipe'
import prop from 'lodash/fp/prop'
import Moment from 'moment';
import * as React from 'react'
import {FormGroup, FormText, Input, Label} from 'reactstrap'
import * as ReactStrap from 'reactstrap'
import * as Help from '../help'
import './styles.css'
import * as Types from './types'

export const hideOnMobile = 'd-none d-sm-block d-sm-none d-md-block d-md-none d-lg-block'

interface ComponentProps {
  disabled?: boolean,
  formText?: string,
  helpType?: string,
  icon?: string,
  label?: string,
  placeholder?: string,
  onChange: any,
  required?: boolean,
  validation?: Types.Validation,
  value: any,
}
type Props = ComponentProps & ReactStrap.InputProps

const emptyValidation: Types.Validation = {
  invalid: false,
  message: '',
}

export const RasaInput =
  ({
    disabled = false,
    formText = null,
    helpType = null,
    icon = null,
    label,
    placeholder,
    onChange,
    required = false,
    type = 'text',
    validation = emptyValidation,
    value,
    // tslint:disable-next-line
    ...props
  }: Props) =>
  <div>
    {label &&
      <Label className={classnames('field-label', { 'disabled-label': disabled, 'required': required })}>
        <span className="field-label-text">{label}</span>
        {helpType && <Help.Help helpType={helpType} id={label} />}
        {validation.invalid &&
          <i className={`fa fa-exclamation-triangle icon-error ${hideOnMobile}`} aria-hidden="true"></i>}
      </Label>
    }
    <FormGroup className={classnames({invalid: validation.invalid, disabled})}>
      <Input
        {...props}
        type={type}
        invalid={validation.invalid}
        className="field-input"
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        onChange={onChange}
        value={value || ''}>
      </Input>
      {icon && <i className={`fas fa-${icon}`}></i>}
      {formText && <FormText>{formText}</FormText> }
    </FormGroup>
    {validation.invalid && <span className="sub-error-text">{validation.message}</span>}
  </div>

type NumberProps = ComponentProps & {
  step?: number,
}

export const RasaNumericInput =
  ({
    disabled = false,
    helpType = null,
    label = null,
    placeholder = 'Enter numeric value',
    onChange,
    required = false,
    step = 1,
    validation = emptyValidation,
    value,
  }: NumberProps) =>
  <div className="rasa-input">
    {label &&
    <Label className={classnames('field-label', { 'disabled-label': disabled, 'required': required })}>
      <span className="field-label-text">{label}</span>
      {helpType && <Help.Help helpType={helpType} id={label} />}
      {validation.invalid &&
        <i className={`fa fa-exclamation-triangle icon-error ${hideOnMobile}`} aria-hidden="true"></i>}
    </Label>}
    <FormGroup className={classnames({invalid: validation.invalid, disabled})}>
      <Input
        invalid={validation.invalid}
        className="field-input field-input-numeric"
        type="number" step={step}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        onChange={onChange}
        value={value}>
      </Input>
      {validation.invalid &&
        <i className={`fa fa-exclamation-triangle icon-error ${hideOnMobile}`} aria-hidden="true"></i>}
    </FormGroup>
    {validation.invalid && <span className="sub-error-text">{validation.message}</span>}
  </div>

type DropdownProps = ComponentProps & {
  options: Types.DropdownOption[],
}

export const RasaSelectInput =
  ({
    disabled = false,
    helpType = null,
    label,
    onChange,
    options,
    required = false,
    validation = emptyValidation,
    value,
  }: DropdownProps) =>
  options.length > 0 && <div className="rasa-input">
    {label &&
      <Label className={classnames('field-label', { 'disabled-label': disabled, 'required': required })}>
        <span className="field-label-text">{label}</span>
        {helpType && <Help.Help helpType={helpType} id={label} />}
        {validation.invalid &&
          <i className={`fa fa-exclamation-triangle icon-error ${hideOnMobile}`} aria-hidden="true"></i>}
      </Label>}
    <FormGroup>
    <Input
      className={classnames({invalid: validation.invalid, disabled}, 'field-input')}
      type="select"
      name="select"
      disabled={disabled}
      onChange={onChange}
      value={value || ''}>
    {options.map((item) => <option key={item.key} value={item.key}>{item.description}</option>)}
    </Input>
    </FormGroup>
  </div>

const selectDate = (onChange: any) => pipe(
  prop('value'),
  (date: Date) => Moment(date),
  (date: Moment.Moment) => date.isValid() ? date.format('YYYY-MM-DD') : null,
  (dateString: string) => dateString && onChange(dateString),
)

export const RasaDatePicker =
  ({
    disabled = false,
    helpType = null,
    label,
    onChange,
    required = false,
    validation = emptyValidation,
    value,
  }: ComponentProps) =>
  <div className="rasa-input">
    {label &&
      <Label className={classnames('field-label', { 'disabled-label': disabled, 'required': required })}>
        <span className="field-label-text">{label}</span>
        {helpType && <Help.Help helpType={helpType} id={label} />}
        {validation.invalid &&
          <i className={`fa fa-exclamation-triangle icon-error ${hideOnMobile}`} aria-hidden="true"></i>}
      </Label>}
    <DatePicker
      popup={
        (props) => <Popup {...props}
          popupAlign={{horizontal: 'right', vertical: 'top'}}
          anchorAlign={{horizontal: 'right', vertical: 'bottom'}}
        />
      }
      className={classnames({invalid: validation.invalid, disabled}, 'field-input')}
      onChange={(e: any) => selectDate(onChange)(e)}
      value={value ? Moment(value).toDate() : null}/>
  </div>



// WEBPACK FOOTER //
// ./src/components/rasa-input/component.tsx